import { api } from '@/shared/services/api'

type FinishChallengeParams = {
  uid: string
  answer: string
  voucherId?: string
  rightAnswer: boolean
}

export function getLevelRecordPath(levelUid: string) {
  return `/user/levels/${levelUid}`
}

export async function finishChallenge({
  uid,
  answer,
  voucherId,
  rightAnswer
}: FinishChallengeParams) {
  const record = voucherId
    ? { voucher_id: voucherId }
    : { answer, right_answer: rightAnswer }

  await api.post(`/user/challenges/${uid}/finish`, { record })
}
